import { FC } from 'react';
import MuiDivider, { DividerProps } from '@mui/material/Divider';

export const Divider: FC<DividerProps> = props => {
  return <MuiDivider {...props} />;
};
